module.exports = __webpack_public_path__ + "img/8e77b26115cf88a8bf3ce76dd434f0de.png";